import { Component, EventEmitter } from '@angular/core'
import { Router } from '@angular/router';
import { SitesService } from '../../../services/sites.service';

@Component({
  selector: 'site-editor',
  templateUrl: './site-editor.component.html',
  styleUrls: ['./site-editor.component.css']
})

export class SiteEditorComponent {
  newSite: Object = {
    label: ''
  }
  

  constructor(
    private sitesService: SitesService,
    private router: Router
  ) {}

  ngOnInit() {
    //we have the data we need
    console.log('bla', this.newSite);
  }

  save() {
    this.sitesService.createSite(this.newSite)
      .subscribe(result => {
        console.log(result);
        this.router.navigate([`sites/${result.id}`]);
      })
    ;
  }
}